/**
 * Stocke le token CSRF et le temps d'expiration
 * @param expiryTimeInMs - Temps d'expiration en millisecondes
 */
export function loginStore(expiryTimeInMs: number): void {
  if (window.location.hash ?? false) {
    const now = new Date();
    const item = {
      CSRF_Token: window.location.hash.slice(1),
      expiry: now.getTime() + expiryTimeInMs,
    };
    localStorage.setItem("isConnected", JSON.stringify(item));
  }
}

/**
 * Supprime le token CSRF
 */
export function loginRemove(): void {
  localStorage.removeItem("isConnected");
}

/**
 * Actualise le token CSRF
 * @param expiryTimeInMs - Temps d'expiration en millisecondes
 */
export function loginRefresh(expiryTimeInMs: number): void {
  const cache = localStorage.getItem("isConnected");
  const item = cache ? JSON.parse(cache) : {};
  if (item) {
    const now = new Date();
    localStorage.setItem(
      "isConnected",
      JSON.stringify({...item, expiry: now.getTime() + expiryTimeInMs})
    );
  }
}

/**
 * Vérifie si l'utilisateur est connecté
 * @returns - true si l'utilisateur est connecté, false sinon
 */
export function loginCheck(): boolean {
  const now = new Date();
  const cache = localStorage.getItem("isConnected");
  const {expiry = now} = cache ? JSON.parse(cache) : {};

  if (now.getTime() >= expiry) {
    localStorage.removeItem("isConnected");
    return false;
  }

  return true;
}

/**
 * Récupère le token CSRF
 * @returns - Token CSRF
 */
export function getCSRF_Token(): string | undefined | null {
  if (loginCheck()) {
    const cache = localStorage.getItem("isConnected");
    const {CSRF_Token} = cache ? JSON.parse(cache) : {};
    return CSRF_Token;
  }
}
